// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:23
import { ZoneAdminAssociation_abstract } from './../abstract/SagaBase/ZoneAdminAssociation_abstract';
export class ZoneAdminAssociation extends ZoneAdminAssociation_abstract {}
